import React from 'react';
import { Dumbbell, Heart, Award, BarChart3 } from 'lucide-react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <div className="flex flex-col items-center text-center p-6 transition-transform duration-300 hover:scale-105">
      <div className="text-red-600 mb-4">{icon}</div>
      <h3 className="text-white text-lg font-bold mb-2">{title}</h3>
      <p className="text-gray-400">{description}</p>
    </div>
  );
};

const Features: React.FC = () => {
  const features = [
    {
      icon: <Dumbbell size={36} />,
      title: "CUSTOMIZED WORKOUTS",
      description: "Training programs tailored specifically to your body type, goals, and lifestyle."
    },
    {
      icon: <Heart size={36} />,
      title: "NUTRITION GUIDANCE",
      description: "Detailed meal plans and nutrition advice to optimize your results."
    },
    {
      icon: <BarChart3 size={36} />,
      title: "PROGRESS TRACKING",
      description: "Monitor your transformation with easy-to-use tools and regular check-ins."
    },
    {
      icon: <Award size={36} />,
      title: "EXPERT 24/7 SUPPORT",
      description: "Direct access to professional coaching from Kelivin 24/7 and motivation when you need it most."
    }
  ];

  return (
    <section className="bg-black py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
          TRANSFORM YOUR BODY WITH PROFESSIONAL GUIDANCE
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;